import { Results } from './../Results/Results';
import { BUTTON_SECTION_HEIGHT_PERCENTEGES } from 'constants/index';
import styled from 'styled-components';
import { Input } from 'components/fields/Input/Input';
import { Button } from 'components/Button/Button';
import { device } from 'constants/index';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 100px 100px 0;
  @media ${device.lg} {
    padding: 30px 0 0;
  }
  @media ${device.md} {
    padding: 60px 0 0;
  }
`;

const ResultWrapper = styled.div`
  width: 100%;
  padding: 0 120px 30px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 70px;
  border-bottom: 1px solid #D9D9D9;
  @media ${device.lg} {
    padding: 0 30px 0;
    border-bottom: none;
    gap: 40px;
  }
  @media ${device.md} {
    padding: 0 30px 0;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 0;
    border: none;
    margin-bottom: 42px;
  }
`

const ResultPageImage = styled.img`
  width: 420px;
  height: 420px;
  border-radius: 5px;
  flex-shrink: 0;
  object-fit: cover;
  @media ${device.md} {
    display: none;
  }
`

const ResultDescription = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  @media ${device.lg} {
    padding-top: 0;
  }
  @media ${device.md} {
    padding-top: 0;
  }
`

const ResultTitle = styled.h1`
  color: #1C1C1C;
  font-family: "Dexa Pro Expanded";
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 48px;
  @media ${device.md} {
     font-size: 30px;
     padding-top: 0px;
  }
`

const ResultHelp = styled.p`
  margin: 30px 0 20px;
  color: #4069ED;
  font-family: "Dexa Pro Expanded";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  @media ${device.lg} {
    margin: 10px 0 10px;
  }
  @media ${device.md} {
     margin: 25px 0 20px;
  }
`

const ResultsList = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
  height: 100%;
  padding-left: 20px;
  overflow-y: auto;
  max-height: 272px;
  @media ${device.lg} {
    max-height: 100%;
  }
  @media ${device.sm} {
    max-height: 124px;
  }

`

const ResultItem = styled.li`
  text-decoration: none;
  list-style: square;
  color: #5F5F63;
  font-family: "Dexa Pro";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  max-width: 490px;
  @media ${device.md} {
     font-size: 16px;
  }
`

const EmailWrapper = styled.div`
  width: 1000px;
  border-radius: 10px;
  background: #1C1C1C;
  margin: 30px 0 0;
  padding: 30px;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 70px;
  @media ${device.md} {
    width: 100%;
    height: 100%;
    margin: 0;
    border-radius: 0;
    flex-direction: column;
    align-items: center;
    padding: 30px;
    gap: 0;
  }
`

const EmailDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media ${device.md} {
    align-items: flex-start;
    margin-bottom: 40px;
  }
`

const EmailHeader = styled.h2`
  color: #F1F1F1;
  font-family: "Dexa Pro Expanded";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 15px;
`

const EmailText = styled.p`
  color: #A8A9AD;
  font-family: "Dexa Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  max-width: 380px;
  @media ${device.md} {
    max-width: 100%;
  }
`

const EmailInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  @media ${device.md} {
    align-items: center;
    width: 100%;
  }
`

const EmailInput = styled(Input)`
  padding: 5px 20px;
  min-width: 490px;
  border-radius: 5px;
  border: none;
  background: #464545;

  &::placeholder {
    color: #D9D9D9;
    opacity: 1;
    font-family: "Dexa Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
  }

  color: #D9D9D9;
  font-family: "Dexa Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;

  @media ${device.md} {
    width: 100%;
    min-width: 100%;
    padding: 18px 20px;
  }
`

const BottomButton = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 12px 25px;
  max-width: 200px;
  @media ${device.md} {
    width: 100%;
    max-width: 100%;
    height: 65px;
  }
`

const ButtonText = styled.span``

const ButtonContent = styled.div``


const ThankWrapper = styled.div`
  width: 1000px;
  height: 181px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #1C1C1C;
  margin: 30px 0 0;
  @media ${device.md} {
    width: 100%;
    height: 100%;
    margin: 0;
    border-radius: 0;
    flex-direction: column;
    align-items: center;
    padding: 50px 30px 70px;
    gap: 0;
  }
`
const ThankTitle = styled.h2`
  color: #F1F1F1;
  text-align: center;
  font-family: "Dexa Pro Expanded";
  font-size: 27px;
  font-style: normal;
  font-weight: 500;
  line-height: 48px;
  @media ${device.md} {
     font-size: 20px;
  }
`

const ThankText = styled.p`
  color: #A8A9AD;
  text-align: center;
  font-family: "Dexa Pro";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  @media ${device.md} {
     font-size: 16px;
  }
`

export { 
  Wrapper,
  ResultWrapper,
  ResultPageImage,
  ResultDescription,
  ResultTitle,
  ResultHelp,
  ResultsList,
  ResultItem,
  EmailWrapper,
  EmailDescription,
  EmailHeader,
  EmailText,
  EmailInputWrapper,
  EmailInput,
  BottomButton,
  ButtonText,
  ButtonContent,
  ThankWrapper,
  ThankTitle,
  ThankText
};
